// removed by extract-text-webpack-plugin
module.exports = {"packagesWrapper":"_1mQLdk6TXx1WSvILKm5iFT","title":"_60Kghr2U_K0KAMM5lmhXk","couponWrapper":"_2bJbHrPTU8-Raj8n8hrQNc","tax":"_3ombiR7Jja9Ic4LNFd_y-c","link":"AXbDGO8uBeAyMvDY1VrT3","packageSwitch":"nYKhMdceA8SZ0-UmwvTim","switcherDescription":"_1pBeP2QcbORuWvwBKR0TsI","stock":"_3RVnb5gvO-kKSHp9TxrqCA","mobileTopBlock":"_1lcHOpbfwYkoO4SPv7N0Zs","chipsWrapper":"_1xRiHdRTXu3TFqADCyVYMN","square":"_1I4bWZxP30BScJ7wnMNzrb","chipsButton":"_3GGO8NayLnI0Eb25vdOE7P","packageItemWrapper":"_37WZlpUtaAvEdTWb_R5ipp","points":"_2Pi1XYPAhT2x4NUm1Hzt4x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPackagesWrapper/RealtorPackageWrapper.scss
// module id = 1729
// module chunks = 0